import * as React from 'react';
import { useSelector } from 'react-redux';
import { Loader } from 'shared/components/admin/Loader';
import { selectLoading } from 'shared/selectors/admin/loader';

export const LoaderContainer: React.FC = () => {
  const isLoading = useSelector(selectLoading);

  if (!isLoading) {
    return null;
  }

  return <Loader />;
};
